import PropTypes from "prop-types";
import React from "react";
import DialGuege from "../HomeCharts/DialGuege";

const DialGuegeLayout = ({ data, mainDashboard, dialChangeKey, apiData }) => {
  return <DialGuege {...{ data, mainDashboard, dialChangeKey, apiData }} />;
};

export default DialGuegeLayout;

DialGuegeLayout.propTypes = {
  data: PropTypes.object.isRequired,
  mainDashboard: PropTypes.bool,
  dialChangeKey: PropTypes.number,
  apiData: PropTypes.object,
};

//!  have to remove on full optimization
